import { getAssignToolQueryKey } from 'infrastructure/hooks/rpm/assign-tool/use-get-assign-tool';
import { useQueryClient } from '@tanstack/react-query';
import CountdownTimer from 'components/atoms/countdown-timer';
import { useTranslation } from 'react-i18next';
import ClockIcon from 'components/atoms/icons/clock.svg?react';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';

import PatientCell from './patient-cell';
import s from './styles.module.scss';
import OptionCell from './option-cell';

import type { IAssignTool } from 'infrastructure/interfaces';
import type { FC } from 'react';

interface MobileTableProps {
  patients?: IAssignTool[];
  isLoading: boolean;
  toggleOpen: () => void;
}

const MobileTable: FC<MobileTableProps> = ({
  patients,
  isLoading,
  toggleOpen,
}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return (
    <BaseSpinWrapper spinning={isLoading}>
      <div className={s['mobile-table-wrapper']}>
        {patients?.map((patient) => {
          const endTime = patient.assignee?.expireAtTimestamp
            ? new Date(patient.assignee.expireAtTimestamp)
            : null;

          return (
            <div key={patient.guid} className={s['mobile-table-item']}>
              <div key={patient.guid} className={s['mobile-table-info']}>
                <PatientCell
                  key={patient.guid}
                  name={patient.name}
                  guid={patient.guid}
                  language={patient.language}
                  dob={patient.dob}
                  toggleOpen={toggleOpen}
                />
              </div>
              <div className={s['mobile-table-actions']}>
                <div className={s['time-remaining-wrapper']}>
                  <p>{t('overviewDashboard.timeRemaining')}</p>
                  <ClockIcon className={s['clock-icon']} />
                  {endTime ? (
                    <CountdownTimer
                      endTime={endTime}
                      isNegative
                      onFinish={() => {
                        const queryKey = getAssignToolQueryKey();
                        queryClient.invalidateQueries(queryKey);
                      }}
                    />
                  ) : (
                    ''
                  )}
                </div>
                <div className={s['mob-assign-wrapper']}>
                  <OptionCell patientGuid={patient.guid} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </BaseSpinWrapper>
  );
};
export default MobileTable;
